<template>
  <ErrorBase
    error-code="404"
    :title="$t('sbErrorPages.title')"
    :sub-title="$t('sbErrorPages.sbFourOhFour.subTitle')"
  >
    <div class="help">
      <h3><sb-text value="sbErrorPages.sbFourOhFour.helpfulLinks" />:</h3>
      <ul class="links">
        <li>
          <a
            target="_blank"
            href="https://web.shipbob.com"
          >
            <sb-text value="common.dashboard" />
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href="https://support.shipbob.com"
          >
            ShipBob <sb-text value="common.helpCenter" />
          </a>
        </li>
      </ul>
    </div>
  </ErrorBase>
</template>

<script>
import SbText from '@src/components/Text/SbText.vue';
import ErrorBase from '@src/pages/Error/components/ErrorBase.vue';

/**
 * Shows how to layout and structure a 404 page.
 */
export default {
  name: 'FourOhFour',
  components: {
    ErrorBase,
    SbText,
  },
  status: 'ready',
};
</script>

<style scoped lang="scss">
@import '@src/pages/Error/style/four-oh-four.scss';
</style>
